import React, {Component} from "react";
import {connect} from 'react-redux';
import styles from '../view/stockVideo/photo/FJPhotoMedias.module.less';
import classNames from 'classnames';
import FJMediaCollectionView from "../view/stockVideo/FJMediaCollectionView";
import FJPhotoSearchView from "../view/stockVideo/photo/FJPhotoSearchView";
import {FJStockVideoAction} from "../../../redux/action/FJRoot.action";
import FJUtil from "../../../util/FJUtil";
import FJSearch from "../view/stockVideo/search/FJSearch";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJConfig from "../../../config/FJConfig";
import FJMedia from "../../../store/FJMedia";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJLocalStore from '../../../store/FJLocalStore'

class FJPhotoMediasContainer extends Component {

  constructor(props) {
    super(props);
    const random = FJUtil.random;
    this.collections = this.handelCollection([
      {
        url: 'Business.jpg',
        name: 'Business',
        keywords: random(['working', 'meeting', 'office', "currency", "company", "consulting", "ecommerce", "teamwork", "management", "marketing", "finance", "insurance", "accounting", "businessman"], 3)
      },
      {
        url: 'Sale.jpg',
        name: 'Sale',
        keywords: random(['promo', 'shop', 'store', "sell", "discount", "offer", "new arrival", "retail", "pricing", "coupon", "deal", "cart"], 3)
      },
      {
        url: 'Fashion.jpg',
        name: 'Fashion',
        keywords: random(['clothes', 'style', 'handbag', "makeup", "model", "jewelry", "hipster", "hairstyle", "salon", "boutique", "sunglasses", "trend"], 3)
      },
      {
        url: 'Technology.jpg',
        name: 'Technology',
        keywords: random(['network', 'smartphone', 'computer', "laptop", "bluetooth", "app", "WiFi", "robot", "AR", "digital", "science", "data"], 3)
      },
      {
        url: 'Real_Estate.jpg',
        name: 'Real Estate',
        keywords: random(['house', 'home', 'indoor', "window", "interior design", "architecture", "apartment", "villa", "mortgage", "realtor", "construction", "rent"], 3)
      },
      {
        url: 'Animal.jpg',
        name: 'Animal',
        keywords: random(['pet', 'dog', 'cat', "bird", "zoo", "wildlife", "fish", "tiger", "lion", "eagle", "rabbit", "wolf"], 3)
      },
      {
        url: 'Entertainment.jpg',
        name: 'Entertainment',
        keywords: random(['happy', 'smile', 'movie', "leisure", "gaming", "gamepad", "xbox", "esport"], 3)
      },
      {
        url: 'Music.jpg',
        name: 'Music',
        keywords: random(['guitar', 'singer', 'microphone', "rock", "CD", "DJ", "rap", "band", "concert", "jazz", "blues", "piano"], 3)
      },
      {url: 'Event.jpg', name: 'Event', keywords: random(['family', 'birthday', 'gift', "reunion", "party"], 3)},
      {
        url: 'Nature.jpg',
        name: 'Nature',
        keywords: random(['spring', 'flower', 'leaf', "beach", "tree", "sky", "sea", "wave", "mountain", "river", "water", "sun", "rain", "cloud", "night", "storm", "star"], 3)
      },
      {
        url: 'Sport.jpg',
        name: 'Sport',
        keywords: random(['gym', 'soccer', 'football', "fitness", "basketball", "yoga", "golf", "tennis", "cycling", "baseball", "cricket", "swimming", "NBA"], 3)
      },
      {
        url: 'Education.jpg',
        name: 'Education',
        keywords: random(['university', 'college', 'classroom', "study", "teacher", "library", "graduation", "book", "student", "school", "pen", "lab"], 3)
      },
      {
        url: 'Travel.jpg',
        name: 'Travel',
        keywords: random(['map', 'backpacking', 'beach', "traveler", "hiking", "hotel", "camping", "journey", "scenery", "landscape", "adventure", "resort", "vacation", "Paris"], 3)
      },
      {
        url: 'Celebration.jpg',
        name: 'Celebration',
        keywords: random(['Christmas', 'New Year', 'Halloween', "Valentine's Day", "Father's Day", "Mother's Day", "Easter", "Thanksgiving", "Holiday", "festival", "carnival"], 3)
      },
      {
        url: 'Food.jpg',
        name: 'Food',
        keywords: random(['restaurant', 'drink', 'coffee', "bakery", "fruit", "vegetable", "dessert", "wine", "beer", "fast food", "cake", "candy"], 3)
      },
      {
        url: 'Photography.jpg',
        name: 'Photography',
        keywords: random(['camera', 'drone', 'portrait', "lens", "film", "GoPro", "backlighting", "panorama", "bokeh", "tripod"], 3)
      },
      {
        url: 'Kids.jpg',
        name: 'Kids',
        keywords: random(['toy', 'preschool', 'baby', "children", "cartoon", "infant", "babysitting", "superhero", "childcare", "kindergarten", "girl", "boy"], 3)
      },
      {
        url: 'Transportation.jpg',
        name: 'Transportation',
        keywords: random(['racing', 'driver', 'tire', "wheel", "limousine"], 3)
      },
      {url: 'Art.jpg', name: 'Art', keywords: random(['musuem', 'dance', 'paint', "graffiti", "DIY", "craft"], 3)},
      {
        url: 'Wedding.jpg',
        name: 'Wedding',
        keywords: random(['bride', 'marriage', 'love', "engagement", "anniversary"], 3)
      },
      {
        url: 'Industrial.jpg',
        name: 'Industrial',
        keywords: random(['engineering', 'plumbing', 'welding', "electric", "mining", "mechanic"], 3)
      },
    ]);

		this.viewInfo = {
			baseWidth: 349,
			space: 271
		}
  }

  handelCollection = (photoCollections) => {
    photoCollections.forEach(item => {
      item.cover = FJConfig.stockPhotoResource + item.url
    })
    return photoCollections;
  }

  _onSearch = (value) => {
    const {onSearchImage} = this.props;
    onSearchImage(value, 1);
  };

	_onRetry = () => {
		const {page, keywords} = this.props;
		const {onSearchImage} = this.props;
		onSearchImage(keywords, page);
	};

  _collectionSearch = (value, localName) => {
  	this._onSearch(localName.toLowerCase());
  };

  _onNextPage = () => {
    const {page, keywords, searchMode, total} = this.props;
    const {onSearchImage} = this.props;
	  if (total && searchMode === FJViewConstant.STOCK_SEARCH_SUCCESS) {
		  onSearchImage(keywords, page + 1);
	  }
  };

  _onChange = (value) => {
    if (value === '') {
      this.props.onClear();
    }
  };

  _onSubmit = (id, preSelected, url, options) => {
    // 做埋点统计
    if (!preSelected) {
      FJUtil.ealog(
          'add stock media',
          {
            'media type': 'photo',
            'keywords': this.props.keywords,
            editor: 'timeline'
          });
    }
    this.props.toggleStockMedia(id, FJCoreConstant.IMAGE, FJMedia.MediaFromType().UNSPLASH, !preSelected, url, options)
  };

  render() {
    const {onClear, onPreview, onClearHistory, mediaList} = this.props;
	  const {active, total, keywords, searchImages, history, searchMode, imagePanelType} = this.props;
    const slectedIds = mediaList
      .filter(media => searchImages.find(image => image.id === media.id))
      .map(media => media.id);
    return (
      <div className={classNames(styles.photo_container, {[styles.active]: active})}>
        <FJSearch onSortChange={this._onSortChange}
                  placeHolder={FJLocalStore._('search-photo')}
                  photoStyle
                  onSubmit={this._onSearch}
                  onChange={this._onChange}
                  onClear={onClear}
                  onClearHistory={onClearHistory}
                  value={keywords}
                  history={history}
        />
        <FJMediaCollectionView collections={this.collections}
                               hasShadow
                               active={active && imagePanelType === 1}
                               onSearch={this._collectionSearch}
        />
        <FJPhotoSearchView active={active && imagePanelType === 2}
                           searchStatus={FJUtil.getStatusWithStockSearch(searchMode, total, searchImages.length)}
                           collections={searchImages}
                           slectedIds={slectedIds}
                           onPreview={onPreview}
                           keywords={keywords}
                           total={total}
                           onRetry={this._onRetry}
                           onSearch={this._onSearch}
                           onSubmit={this._onSubmit}
                           searchKeyword={keywords}
                           searchNextPage={this._onNextPage}
													 viewInfo={this.viewInfo}
        />
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    mediaList: state.media.mediaList,
    searchImages: state.stock.searchImages,
    keywords: state.stock.searchImageKeyword,
    history: state.stock.searchImageHistory,
    searchMode: state.stock.searchImageMode,
    total: state.stock.searchImageTotal,
    page: state.stock.searchImagePage,
    imagePanelType: state.stock.imagePanelType,
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    onPreview: function (data) {
      dispatch(FJStockVideoAction.setStockDetailModalAction(data))
    },
    onSearchImage: function (keywords, page) {
      dispatch(FJStockVideoAction.searchImageAction(keywords, page))
    },
    onClearHistory: function () {
			dispatch(FJStockVideoAction.deleteVideoHistoryAction(FJViewConstant.SEARCH_STOCK_IMAGE))
    },
    toggleStockMedia: function (id, type, fromType, toggle, url, options) {
      dispatch(FJStockVideoAction.toggleStockMediaAction(id, type, fromType, toggle, url, options))
    },
    onClear: function () {
      dispatch(FJStockVideoAction.clearImageSearchAction());
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJPhotoMediasContainer);
